var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chart-container"},[_c('simple-chart',{attrs:{"options":_vm.options,"series":_vm.series,"is-loading":_vm.isLoading,"name":"Booking"},on:{"setChart":_vm.setChart}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }